module.exports = __webpack_public_path__ + "static/media/rose.c9e7f666.png";